import { css } from '@emotion/react'
import { CornerRadius, FontWeight, Spacing } from '@opallabs/gem'

/** A group's color dot, and the room a row without one leaves for it. */
const dotSize = Spacing.S
/** Between a row's dot, its label and its count. */
const rowGap = Spacing.XS * 1.5

export const body = css({
  // Wide enough that a short group name still leaves the counts in a column.
  minInlineSize: Spacing.XS * 45,
})

export const heading = css({
  fontWeight: FontWeight.Semibold,
  marginBlockEnd: Spacing.XS,
})

export const row = css({
  alignItems: 'center',
  display: 'flex',
  // The tooltip is set in Semibold and Gem's lightest weight is Medium, so a
  // plain row has to ask for a weight no token carries.
  fontWeight: 400,
  gap: rowGap,
  lineHeight: 1.4,
})

/** A leaf lines up with its parent's label, past the parent's dot. */
export const rowInset = css({ paddingInlineStart: dotSize + rowGap })

/** A parent row, which carries the total for everything under it. */
export const rowTotal = css({ fontWeight: FontWeight.Semibold })

/** The fill comes from the group the dot stands for. */
export const dot = css({
  blockSize: dotSize,
  borderRadius: CornerRadius.XSmall,
  display: 'inline-block',
  flexShrink: 0,
  inlineSize: dotSize,
})

/** Stands in for a dot, so a row without one starts where the others do. */
export const dotSpacer = css({ inlineSize: dotSize })

export const rowLabel = css({ flex: 1 })
